import { useEffect } from 'react';
import type { FallbackProps } from 'react-error-boundary';

import { emitRefreshPrompted, REFRESH_PROMPT_MESSAGE } from '../chunkLoadRecovery';
import { isRecoverableChunkError } from '../utilities/loadableRetry';
import AppCrash from './AppCrash';

// Mirrors AppCrash's layout so a chunk failure reads as a routine "new version" prompt rather
// than an app crash — which is what it is. The user's work is not lost; the code just is not here yet.
const ChunkRefresh = () => {
    useEffect(() => {
        emitRefreshPrompted('error-boundary');
    }, []);

    return (
        <div className="flex min-h-dvh items-center justify-center bg-gray-50 p-8">
            <div className="max-w-[480px] text-center">
                <p className="text-lg font-semibold">A new version is available</p>
                <p className="mb-12 mt-6 text-lg">{REFRESH_PROMPT_MESSAGE}</p>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="min-h-[44px] min-w-[44px] px-6 text-lg font-semibold underline"
                >
                    Refresh page
                </button>
            </div>
        </div>
    );
};

// partners uses React.lazy, so a route chunk that fails to load is re-thrown during render and
// arrives here rather than on window.onerror. Without this branch every such failure showed the
// generic crash screen — the gap that left partner-web as the only frontend with no chunk
// recovery while members and experts each prompted a refresh ~125 times a month.
const CrashFallback = ({ error }: FallbackProps) => (isRecoverableChunkError(error) ? <ChunkRefresh /> : <AppCrash />);

export default CrashFallback;
